import React from 'react';

const JS_2022 = () => {
  return (
    <div >
      <h1>JS_2022</h1>
      <p>Placeholder component for: "JS 2022"</p>
    </div>
  );
};

export default JS_2022;
